module.exports = __webpack_public_path__ + "img/center_alignment.46907ec2.svg";